import React, { useEffect, useImperativeHandle, forwardRef, useState } from 'react';

const WIDGET_CODE = "siq0c95a6b7a2e468cd901af44bf8ded6e80ddb2c53bec9cd2439d5d25e9efd3c7e";

const ZohoChatbot = forwardRef(({ open, onReady }, ref) => {
  const [isInitialized, setIsInitialized] = useState(false);

  const openChat = () => {
    try {
      if (!window.$zoho || !window.$zoho.salesiq) {
        console.error('Zoho SalesIQ not initialized');
        return false;
      }

      // Use the floatwindow.visible method specifically
      if (window.$zoho.salesiq.floatwindow && typeof window.$zoho.salesiq.floatwindow.visible === 'function') {
        window.$zoho.salesiq.floatwindow.visible('show');
        return true;
      }

      return false;
    } catch (error) {
      console.error('Error opening chat:', error);
      return false;
    }
  };

  useImperativeHandle(ref, () => ({
    openChat,
    isInitialized: () => isInitialized
  }));

  useEffect(() => {
    if (!open) return;

    const initializeZoho = () => {
      try {
        // Initialize using official Zoho code
        window.$zoho = window.$zoho || {};
        window.$zoho.salesiq = window.$zoho.salesiq || {
          ready: function() {
            setIsInitialized(true);
            if (onReady) onReady();
          }
        };

        // Remove any existing script
        const existingScript = document.getElementById('zsiqscript');
        if (existingScript) {
          existingScript.remove();
        }

        // Create and append the script using official URL
        const script = document.createElement('script');
        script.id = 'zsiqscript';
        script.defer = true;
        script.src = `https://salesiq.zohopublic.com/widget?wc=${WIDGET_CODE}`;

        script.onerror = (error) => {
          console.error('Failed to load Zoho chat widget:', error);
          setIsInitialized(false);
        };

        // Insert script before the first script tag
        const firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.insertBefore(script, firstScript);

      } catch (error) {
        console.error('Error initializing Zoho chat:', error);
        setIsInitialized(false);
      }
    };

    // Initialize immediately since we're using the official code
    initializeZoho();

    return () => {
      try {
        const script = document.getElementById('zsiqscript');
        if (script) {
          script.remove();
        }
        setIsInitialized(false);
      } catch (error) {
        console.error('Error cleaning up Zoho chat:', error);
      }
    };
  }, [open, onReady]);

  return null;
});

ZohoChatbot.displayName = 'ZohoChatbot';

export default ZohoChatbot; 